"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _leads = require("@/api/leads");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _clients = require("@/api/clients");
var _admins = require("@/api/admins");
var _clientsContacts = require("@/api/clients-contacts");
var _utils = require("@/utils");
var _ClientsContactDetails = _interopRequireDefault(require("../../clients-contacts/components/ClientsContactDetails.vue"));
var _ConceptDetails = _interopRequireDefault(require("../../master/concepts/components/ConceptDetails.vue"));
var _sources = require("@/api/master/sources");
var _concepts = require("@/api/master/concepts");
var _admin = require("@/store/modules/admin");
var _productsVariations = require("@/api/products-variations");
var _leadsProducts = require("@/api/leads-products");
var _categories = require("@/api/categories");
var _index = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/HelpText/index.vue"));
var _companies = require("@/api/master/companies");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, _leads.defaultLeadData);
    this.clientList = [];
    this.contactList = [];
    this.managerList = [];
    this.coordinatorList = [];
    this.sourceList = [];
    this.conceptList = [];
    this.categoryList = [];
    this.contactDialogVisible = false;
    this.conceptDialogVisible = false;
    this.loggedInAdmin = null;
    this.leadStatusCount = null;
    this.recentLeads = [];
    this.selectedProduct = [];
    this.productList = [];
    this.selectedCategories = [];
    this.companiesList = [];
    this.sourceProductImage = [];
    this.loading = false;
    this.rules = {
      clientId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      clientsContactId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      salesManagerId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      salesCoordinatorId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      sourceId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      // conceptId: {
      //   required: true,
      //   message: 'This field is required',
      //   trigger: 'blur'
      // },
      productAction: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      expectedClosureDate: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      quantity: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      budgetPerPiece: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      tentativeDeliveryDuration: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
    this.pickerOptions = {
      disabledDate(time) {
        return time.getTime() < Date.now();
      }
    };
  }
  async getCompanys() {
    const companies = await (0, _companies.getCompanies)({
      sort: 'id,ASC',
      filter: 'enabled||$eq||true'
    });
    this.companiesList = companies;
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    this.loggedInAdmin = _admin.AdminModule;
    this.getCompanys();
    this.fetchManagerList();
    this.fetchCoordinatorList();
    this.fetchSourceList();
    this.fetchCategoryList();
    const query = this.$route.query;
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      // ✅ IMPORTANT: mutate instead of replace
      Object.assign(this.formData, _leads.defaultLeadData);
      this.formData.sourcingProductImage = [];
      // 🔥 PREFILL FROM EMAIL FLOW
      // ✅ Client
      if (query.clientId) {
        this.formData.clientId = Number(query.clientId);
        this.fetchClientById();
        this.fetchContactList();
      }
      // ✅ Contact
      if (query.contactId) {
        this.formData.clientsContactId = Number(query.contactId);
        this.fetchContactById();
      }
      // ✅ Email subject → comments/title
      if (query.subject) {
        this.formData.comments = query.subject;
      }
    }
    // default manager
    this.formData.salesManagerId = this.loggedInAdmin.id;
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await (0, _leads.getLeadById)(id);
      this.formData = data;
      if (!this.formData.nextFollowupDuration) {
        this.formData.nextFollowupDuration = '01:00';
      }
      this.selectedCategories = this.formData.category.map(category => category.id);
      if (this.formData.sourcingProductImage) {
        this.formData.sourcingProductImage.forEach(image => this.sourceProductImage.push({
          name: this.formData.sourcingProductName,
          url: image
        }));
      }
      // this.productList = data.leadsProduct
      this.selectedProduct = data.leadsProduct.map(product => product.productsVariationId);
      if (this.selectedProduct && this.selectedProduct.length) {
        this.productList = await (0, _productsVariations.getVariations)((0, _utils.getQuery)({
          limit: 10,
          enabled: true,
          id: this.selectedProduct,
          'product.enabled': true,
          filter: {
            enabled: '$eq',
            id: '$in',
            name: '$contL',
            'product.enabled': '$eq'
          }
        }));
      }
      // fetch client
      this.fetchClientById();
      // fetch contact
      this.fetchContactById();
      // get recent leads
      this.getRecentLeads();
      // get status count
      this.getLeadCountByStatus();
      // Just for test
      const title = 'Lead';
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async selectCordinator() {
    if (this.formData.salesManagerId) {
      // check if salesManger has cordinator
      if (!this.isEdit) {
        const data = await (0, _admins.getAdminById)(this.formData.salesManagerId);
        if (data && data.coordinatorId) {
          this.formData.salesCoordinatorId = data.coordinatorId;
        }
      }
    }
  }
  async fetchClientList(query = '', force = false) {
    try {
      console.log('DEBUG: fetchClientList triggered', {
        companyId: this.formData.companyId,
        query,
        force
      });
      if (query.length > 0 || force) {
        this.clientList = await (0, _clients.getClients)((0, _utils.getQuery)({
          limit: 10,
          filter: {
            enabled: '$eq',
            companyId: '$eq',
            name: '$contL'
          },
          enabled: true,
          companyId: this.formData.companyId,
          name: query || undefined
        }));
        console.log('DEBUG: Client list updated', this.clientList);
      }
    } catch (error) {
      console.error('DEBUG: Fetch failed', error);
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchCategoryList() {
    try {
      this.categoryList = await (0, _categories.getCategories)((0, _utils.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchClientById() {
    if (this.formData.clientId) {
      const data = await (0, _clients.getClientById)(this.formData.clientId);
      this.clientList = [data];
      if (data.companyId) {
        this.formData.companyId = data.companyId;
      }
    }
  }
  async onContactChange() {
    if (this.formData.clientsContactId) {
      // fetch recent leads
      this.getRecentLeads();
      const currentLoggedInAdmin = _admin.AdminModule;
      if (currentLoggedInAdmin.roles.includes('Sales Manager')) {
        this.formData.salesManagerId = currentLoggedInAdmin.id;
        this.selectCordinator();
      }
    }
  }
  onClientChange() {
    if (this.formData.clientId) {
      const index = this.clientList.findIndex(client => client.id === this.formData.clientId);
      this.formData.categorization = this.clientList[index].categorization;
    }
    // fetch associated contacts
    this.fetchContactList();
    // get won/lost count
    this.getLeadCountByStatus();
  }
  onCompanyChange() {
    console.log('this.formData.companyId', this.formData.companyId);
    this.formData.clientId = null;
    this.formData.clientsContactId = null;
    this.clientList = [];
    if (this.formData.companyId) {
      const index = this.companiesList.findIndex(company => company.id === this.formData.companyId);
      this.formData.categorization = this.companiesList[index].categorization;
    }
    this.fetchClientList('', true);
  }
  async setInquiryCategorization() {
    let inquiryCategorization = '';
    this.formData.budget = (this.formData.budgetPerPiece || 0) * (this.formData.quantity || 0);
    if (this.formData.budget >= 2500000) {
      inquiryCategorization = 'A+';
    } else if (this.formData.budget >= 1000000 && this.formData.budget < 2500000) {
      inquiryCategorization = 'A';
    } else if (this.formData.budget >= 500000 && this.formData.budget < 1000000) {
      inquiryCategorization = 'B';
    } else if (this.formData.budget >= 100000 && this.formData.budget < 500000) {
      inquiryCategorization = 'C';
    } else {
      inquiryCategorization = 'D';
    }
    await this.fetchContactById();
    const clientCategory = this.contactList[0].categorization;
    const categories = ['D', 'C', 'B', 'A', 'A+'];
    let productCategory = 'D';
    const products = this.productList.filter(product => this.selectedProduct.includes(product.id));
    products.forEach(product => {
      if (categories.indexOf(product.product.categorization) > categories.indexOf(productCategory)) {
        productCategory = product.product.categorization;
      }
    });
    // now final categorization of lead
    if (inquiryCategorization === 'A+') {
      this.formData.categorization = 'A+';
    } else if (inquiryCategorization === 'A' || clientCategory === 'A' || productCategory === 'A') {
      this.formData.categorization = 'A';
    } else if (inquiryCategorization === 'B' || clientCategory === 'B' || productCategory === 'B') {
      this.formData.categorization = 'B';
    } else if (inquiryCategorization === 'C' || clientCategory === 'C' || productCategory === 'C') {
      this.formData.categorization = 'C';
    } else {
      this.formData.categorization = 'D';
    }
  }
  async fetchContactList() {
    try {
      this.contactList = [];
      this.formData.clientsContactId = null;
      if (this.formData.clientId) {
        this.contactList = await (0, _clientsContacts.getClientsContacts)((0, _utils.getQuery)({
          enabled: true,
          clientId: this.formData.clientId,
          filter: {
            enabled: '$eq',
            clientId: '$eq'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchContactById() {
    if (this.formData.clientsContactId) {
      const data = await (0, _clientsContacts.getClientsContactById)(this.formData.clientsContactId);
      this.contactList = [data];
    }
  }
  async fetchSourceList() {
    try {
      this.sourceList = await (0, _sources.getSources)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: '$eq'
        }
      }));
      // Prefill source when navigating from email "Add to Lead"
      if (!this.isEdit && this.$route.query.source === 'email') {
        const emailSource = this.sourceList.find(s => {
          var _s$name;
          return (_s$name = s.name) === null || _s$name === void 0 ? void 0 : _s$name.toLowerCase().includes('gmail');
        });
        if (emailSource) {
          this.formData.sourceId = emailSource.id;
        }
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchConceptList() {
    try {
      this.conceptList = await (0, _concepts.getConcepts)((0, _utils.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchManagerList() {
    try {
      this.managerList = await (0, _admins.getAdmins)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchCoordinatorList() {
    try {
      this.coordinatorList = await (0, _admins.getAdmins)((0, _utils.getQuery)({
        enabled: true,
        'adminsRole.name': ['Super Admin'],
        filter: {
          enabled: '$eq',
          'adminsRole.name': '$notin'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getRecentLeads() {
    this.recentLeads = [];
    if (this.formData.clientId) {
      const response = await (0, _leads.getLeads)((0, _utils.getQuery)({
        enabled: true,
        clientId: this.formData.clientId,
        clientsContactId: this.formData.clientsContactId || undefined,
        limit: 5,
        sort: 'id,DESC',
        filter: {
          clientId: '$eq',
          ...(this.formData.clientsContactId ? {
            clientsContactId: '$eq'
          } : {})
        }
      }));
      this.recentLeads = (response.data || []).filter(lead => lead.id !== this.formData.id);
    }
  }
  async getLeadCountByStatus() {
    this.leadStatusCount = null;
    if (this.formData.clientId) {
      const res = await (0, _leads.leadStatusCount)({
        clientId: this.formData.clientId
      });
      if (res && res.data) {
        this.leadStatusCount = res.data;
      }
    }
  }
  async fetchProducts(query = '') {
    try {
      if (query.length > 0) {
        this.productList = await (0, _productsVariations.getVariations)((0, _utils.getQuery)({
          limit: 10,
          enabled: true,
          productId: 0,
          name: query,
          'product.enabled': true,
          filter: {
            enabled: '$eq',
            productId: '$gt',
            name: '$contL',
            'product.enabled': '$eq'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  tootgleContactDialog() {
    this.contactDialogVisible = true;
  }
  tootgleConceptDialog() {
    this.conceptDialogVisible = true;
  }
  handleImageUpload(file) {
    this.formData.sourcingProductImage.push(file.response);
  }
  refresh(event) {
    this.contactDialogVisible = event.showDialog;
    this.conceptDialogVisible = event.showDialog;
    if (event.data && event.data.id) {
      this.formData.clientsContactId = event.data.id;
      this.contactList.push(event.data);
    }
    if (event.savedConcept && event.savedConcept.id) {
      this.formData.conceptId = event.savedConcept.id;
      this.conceptList.push(event.savedConcept);
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        if (this.isEdit) {
          this.saveForm();
        } else {
          this.checkDuplicateLead();
        }
      } else {
        return false;
      }
    });
  }
  async checkDuplicateLead() {
    const res = await (0, _leads.checkDuplicate)({
      clientId: this.formData.clientId,
      clientsContactId: this.formData.clientsContactId,
      quantity: this.formData.quantity
    });
    if (res) {
      if (res.isDuplicate) {
        this.$confirm('A lead with same data already exists. Do you wish to continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.saveForm();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Operation canceled'
          });
          return false;
        });
      } else {
        this.saveForm();
      }
    } else {
      return false;
    }
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      this.actionToBeTakenChecked();
      if (!this.isEdit && this.formData.productAction === 'Send Quote' && this.selectedProduct.length < 1) {
        this.$notify({
          title: 'Failed',
          message: 'Please select at least one product',
          type: 'error',
          duration: 5000
        });
        this.loading = false;
        return;
      }
      this.formData.client = {
        id: this.formData.clientId
      };
      this.formData.clientsContact = {
        id: this.formData.clientsContactId
      };
      this.formData.salesCoordinator = {
        id: this.formData.salesCoordinatorId
      };
      this.formData.salesManager = {
        id: this.formData.salesManagerId
      };
      // if (this.formData.conceptId) {
      //   this.formData.concept = { id: this.formData.conceptId }
      // }
      this.formData.source = {
        id: this.formData.sourceId
      };
      // calc bugdet
      this.formData.budget = this.formData.budgetPerPiece * this.formData.quantity;
      if (this.selectedCategories.length) {
        this.formData.category = this.selectedCategories.map(categoryId => {
          const data = {
            id: categoryId
          };
          return data;
        });
      }
      if (this.isEdit) {
        await (0, _leads.updateLead)(this.formData.id, this.formData);
      } else {
        this.formData.status = 'New';
        this.formData.quotationStatus = 'Yet To Quote';
        if (this.formData.productAction === 'Send Quote' && this.selectedProduct.length) {
          // budget per piece for send quote => average of products price
          let productsTotalPrice = 0;
          const selectedVariations = await (0, _productsVariations.getVariations)((0, _utils.getQuery)({
            id: this.selectedProduct,
            filter: {
              id: '$in'
            }
          }));
          if (selectedVariations.length) {
            for (const item of selectedVariations) {
              productsTotalPrice += parseFloat(item.unitPrice);
            }
          }
          this.formData.budgetPerPiece = Math.floor(productsTotalPrice / selectedVariations.length);
          this.formData.budget = this.formData.budgetPerPiece * this.formData.quantity;
        }
        this.formData.productAction = 'Send Quote';
        const res = await (0, _leads.createLead)(this.formData);
        // save selected products if "Send Quote"
        if (this.formData.productAction === 'Send Quote' && this.selectedProduct.length) {
          // set lead status
          this.formData.status = 'Contacted';
          // process selected products
          const selectedVariations = await (0, _productsVariations.getVariations)((0, _utils.getQuery)({
            id: this.selectedProduct,
            filter: {
              id: '$in'
            }
          }));
          // prepare product data to save
          const leadsProductList = [];
          if (selectedVariations.length) {
            for (const item of selectedVariations) {
              var _item$product, _item$product$product, _item$product2, _item$product3, _item$product4;
              // const total = res.quantity * (item.salePrice || item.unitPrice)
              let unitPrice = item.unitPrice;
              let salePrice = item.unitPrice;
              if (item.quotePrice && item.quotePrice > 0) {
                unitPrice = item.quotePrice;
                salePrice = item.quotePrice;
              } else if (item.salePrice && (item === null || item === void 0 ? void 0 : item.salePrice) > 0) {
                unitPrice = item.salePrice;
                salePrice = item.salePrice;
              }
              const total = res.quantity * unitPrice;
              leadsProductList.push({
                enabled: true,
                leadId: res.id,
                productId: item.productId,
                productName: item.name,
                productsVariation: {
                  id: item.id,
                  name: item.name
                },
                unitPrice: unitPrice,
                salePrice: salePrice,
                margin: item.margin,
                quantity: res.quantity,
                subTotal: total,
                total,
                image1: ((_item$product = item.product) === null || _item$product === void 0 || (_item$product = _item$product.productsImage) === null || _item$product === void 0 ? void 0 : _item$product.length) > 0 ? (_item$product$product = item.product.productsImage.find(img => img.isCover)) === null || _item$product$product === void 0 ? void 0 : _item$product$product.image : (_item$product2 = item.product) === null || _item$product2 === void 0 || (_item$product2 = _item$product2.productsImage[0]) === null || _item$product2 === void 0 ? void 0 : _item$product2.image,
                taxId: ((_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.taxId) || null,
                taxRate: ((_item$product4 = item.product) === null || _item$product4 === void 0 || (_item$product4 = _item$product4.tax) === null || _item$product4 === void 0 ? void 0 : _item$product4.rate) || 0
              });
            }
          }
          await (0, _leadsProducts.addLeadsProducts)(leadsProductList);
        }
        this.formData.id = res.id;
      }
      this.$notify({
        title: 'Success',
        message: 'Lead saved',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      _router.default.push('/follow-ups/list/' + this.formData.id);
    } catch (err) {
      this.loading = false;
    }
  }
  actionToBeTakenChecked() {
    switch (this.formData.productAction) {
      case 'Send Quote':
        this.formData.budgetPerPiece = null;
        this.formData.budget = null;
        this.formData.conceptId = null;
        this.formData.sourcingProductName = null;
        this.formData.sourcingProductImage = [];
        break;
      case 'Send Options':
        this.formData.sourcingProductName = null;
        this.formData.sourcingProductImage = [];
        break;
      case 'Sourcing':
        this.formData.conceptId = null;
        this.formData.selectedProduct = [];
        break;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LeadDetail',
  components: {
    ClientsContactDetail: _ClientsContactDetails.default,
    ConceptDetail: _ConceptDetails.default,
    FileUpload: _index.default,
    HelpText: _index2.default
  }
})], default_1);
var _default = exports.default = default_1;